<template>
  <v-card class="elevation-12">
    <v-toolbar
      dark
      flat
    >
      <v-toolbar-title>Reset Password</v-toolbar-title>
    </v-toolbar>
    <v-form @submit.prevent="resetPassword">
      <v-card-text>
        <v-text-field
          v-model="reset.email"
          label="E-mail"
          prepend-icon="mdi-mail"
          type="email"
          :error-messages="validationsErrors.getMessage('email')"
        />
        <v-text-field
          id="password"
          v-model="reset.password"
          label="Password"
          prepend-icon="mdi-lock"
          type="password"
          :error-messages="validationsErrors.getMessage('password')"
        />
        <v-text-field
          v-model="reset.password_confirmation"
          label="Password Confirmation"
          prepend-icon="mdi-lock"
          type="password"
        />
      </v-card-text>
      <v-card-actions>
        <v-btn to="/login">
          Back to login
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          type="submit"
        >
          Update New Password
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      reset: {
        email: null,
        password: null,
        password_confirmation: null,
        token: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      validationsErrors: "validation/pull",
    }),
  },

  methods: {
    ...mapActions({
      snackbar: "snackbar/show",
    }),
    resetPassword() {
      this.$data.reset.token = this.$route.params.token;
      window.axios
        .post("/password/reset", this.$data.reset)
        .then((response) => {
          this.snackbar(response.data.message);
          this.$router.replace({ name: "Login" });
        });
    },
  },
};
</script>
